import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { getCookies } from 'fetcher';
import { Loading } from 'components';
import { useGetCurrentUserQuery } from 'services';
import { getReturnTo, redirectToReturnTo } from 'utils';

export const AppRedirect = () => {
  const navigate = useNavigate();
  const { isFetching } = useGetCurrentUserQuery();

  useEffect(() => {
    const { token: tokenCookie, refreshToken: rtCookie } = getCookies();
    if (!isFetching) {
      if (tokenCookie && rtCookie) {
        // SSO turu bu adrese dönüyorsa dış dönüş adresi hâlâ bekliyor olabilir.
        const externalReturnTo = getReturnTo();

        if (externalReturnTo) {
          return redirectToReturnTo(externalReturnTo);
        }

        navigate('/anasayfa');
      } else {
        // Oturum yoksa dönüş adresi saklı kalır, girişten sonra devir tamamlanır.
        navigate('/giris');
      }
    }
  }, [navigate, isFetching]);

  return <Loading />;
};
